import React, { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { fetchZonesDD } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { fetchAllocateZoneById } from "services/allocateZone";

const ZoneDropDown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  allZone,
  allOption,
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);
  const auth = useSelector((state) => state.jwtAuthreducer);
  const { employee_code_id } = auth?.user;

  const [zoneId, setZoneId] = useState(localStorage.getItem("zone_id") || null);
  const [allZoneIds, setAllZoneIds] = useState([]);

  const {
    data: allocatedZones,
    isLoading: isAllocatedLoading,
    isError: isAllocatedError,
    error: allocatedError,
    refetch: refetchAllocated,
  } = useQuery(
    ["fetch-allocated-zones", employee_code_id],
    () => fetchAllocateZoneById({ employee_code_id }),
    {
      staleTime: DROPDOWN_STALE_TIME,
      enabled: !!employee_code_id && !allZone,
    }
  );

  const {
    data: allZonesData,
    isLoading: isAllZonesLoading,
    isError: isAllZonesError,
    error: allZonesError,
    refetch: refetchAllZones,
  } = useQuery(["fetch-all-zones"], () => fetchZonesDD({}), {
    staleTime: DROPDOWN_STALE_TIME,
    enabled: allZone,
  });

  useEffect(() => {
    if (allZone) {
      refetchAllZones();
    } else {
      refetchAllocated();
    }
  }, [allZone, login, refetchAllZones, refetchAllocated]);

  const zonesData = allZone
    ? allZonesData?.data?.zone_data
    : allocatedZones?.data;
  const isLoading = allZone ? isAllZonesLoading : isAllocatedLoading;
  const error = allZone ? allZonesError : allocatedError;

  useEffect(() => {
    if (zonesData) {
      const ids = zonesData
        .map((zone) => {
          if (allZone) {
            return zone.id || zone.zone_id;
          } else {
            return zone?.zone_id;
          }
        })
        .filter((id) => id);
      setAllZoneIds(ids);
    }
  }, [zonesData, allZone]);

  const options = useMemo(() => {
    if (!zonesData) return [];

    const mappedZones = zonesData.map((zone) => {
      if (allZone) {
        return {
          value: zone.id || zone.zone_id,
          label: zone.zone_name || zone.name,
        };
      } else {
        return {
          value: zone?.zone_id,
          label: zone?.zone_obj?.zone_name,
        };
      }
    });

    if (allOption) {
      return [{ value: "All", label: "All" }, ...mappedZones];
    }

    return mappedZones;
  }, [zonesData, allZone, allOption]);

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === (rowData?.zone_obj?.id || rowData?.zone_id)
      );
      setValue("zone_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading zones</div>;

  return (
    <>
      <Controller
        name="zone_id"
        control={control}
        rules={{
          required: required ? "Zone is required" : false,
          validate: (value) => {
            if (required && !value) return "Zone is required";
            return true;
          },
        }}
        render={({ field }) => {
          const currentOption =
            options.find((option) => option.value === field.value) || null;

          return (
          <Select
            options={options}
            isClearable
            placeholder="Select Zone"
            value={currentOption}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                height: "42px",
              }),
              option: (base) => ({
                ...base,
              }),
            }}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "";
              field.onChange(value);
              setValue("zone_id", value);

              if (value === "All" && allZoneIds.length > 0) {
                const actualZoneIds = options
                  .filter((opt) => opt.value !== "All")
                  .map((opt) => opt.value);

                setValue("allZoneIds", actualZoneIds);
              } else {
                setValue("allZoneIds", []);
              }
            }}
            className={`react-select-container ${
              errors.zone_id ? "is-invalid" : ""
            }`}
          />
          );
        }}
      />
    </>
  );
};

export default ZoneDropDown;
